import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BreadcrumbModule } from 'xng-breadcrumb';
import { SharedModule } from 'src/app/shared/shared.module';
import { AlertChatLogComponent } from './alert-chat-log/alert-chat-log.component';
import { AlertLogComponent } from './alert-log.component';
import { AlertLogRoutingModule } from './alert-log-routing.module';
import { MatPaginatorModule } from '@angular/material/paginator';
import { AgmCoreModule } from '@agm/core';
import { TranslateModule } from '@ngx-translate/core';
import { NgxSpinnerModule } from 'ngx-spinner';
import { AddActivityComponent } from './add-activity/add-activity.component';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxStripeModule } from '@nomadreservations/ngx-stripe';
import { AuthInterceptorProvider } from '../services/token/token-interceptor.service';


@NgModule({
    declarations: [
        AlertChatLogComponent,
        AlertLogComponent,
        AddActivityComponent
    ],
    imports: [
        AgmCoreModule,
        AlertLogRoutingModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatPaginatorModule,
        BreadcrumbModule,
        NgbModule,
        NgxStripeModule,
        NgxSpinnerModule,
        TranslateModule,
        SharedModule
    ],
    providers: [
        AuthInterceptorProvider,
    ]
})
export class AlertLogModule {}